import { useTranslation } from "react-i18next";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";
import { doorLogsHref, formatLastIn } from "../door-visits-utils";
import LinkButton from "./LinkButton";
import RetryLabel from "./RetryLabel";

const LogsButton = ({ href, disabledReason, label }) => {
  if (disabledReason) {
    return (
      <span className="door-visits-disabled" title={disabledReason}>
        <button type="button" data-button-type="secondary" disabled>
          <SvgIcon
            src="/img/new-icons/door.svg"
            useCurrentColor
            classNames="w-4 h-4 shrink-0"
          />
          {label}
        </button>
      </span>
    );
  }
  return (
    <LinkButton type="secondary" href={href}>
      <SvgIcon
        src="/img/new-icons/door.svg"
        useCurrentColor
        classNames="w-4 h-4 shrink-0"
      />
      {label}
    </LinkButton>
  );
};

/**
 * Membership drawer block under the FaciliKey row: the member's last visit
 * and a link to their door logs. Only rendered for owners and admins of a
 * gym that is connected to FaciliKey. `summary` is the `doorMemberSummary`
 * the controller loaded for this member (missing when it failed).
 */
const MemberDoorVisits = ({
  doorAccess,
  summary,
  memberId,
  memberName,
  keyed,
}) => {
  const { t } = useTranslation("coaching-portal");
  const href = doorLogsHref({ memberId, memberName });
  const label = t("doorAccess.memberVisits.viewLogs");

  if (!keyed) {
    return (
      <div className="door-visits-block">
        <LogsButton
          disabledReason={t("doorAccess.memberVisits.noFacilikey")}
          label={label}
        />
      </div>
    );
  }

  const failed = !summary || summary.error || summary.forbidden;
  const noVisits = !failed && !summary.lastVisitAt;

  return (
    <div className="door-visits-block">
      {failed ? (
        <p className="door-visits-line">
          {t("doorAccess.memberVisits.error")}
          <button
            type="button"
            className="door-visits-retry"
            onClick={() =>
              submit("/actions/refresh", { method: "GET", body: {} })
            }
          >
            <RetryLabel />
          </button>
        </p>
      ) : (
        <p className="door-visits-line">
          {t("doorAccess.memberVisits.lastVisit")}{" "}
          {noVisits ? (
            <span className="door-visits-muted">
              {t("doorAccess.memberVisits.none")}
            </span>
          ) : (
            <>
              <b>{formatLastIn(summary.lastVisitAt, doorAccess.timeZone)}</b>
              <span className="door-visits-muted">
                {" "}
                ·{" "}
                {t("doorAccess.memberVisits.visitsLast4Weeks", {
                  count: summary.visitsLast4Weeks,
                })}
              </span>
            </>
          )}
        </p>
      )}
      <LogsButton
        href={href}
        label={label}
        disabledReason={
          noVisits ? t("doorAccess.memberVisits.noLogs") : undefined
        }
      />
    </div>
  );
};

export default MemberDoorVisits;
